import img1 from '../../static/img/class_types_page/FreeDance_Low_Impact_Dance_Fitness_1.webp';
import img2 from '../../static/img/class_types_page/FreeDance_Low_Impact_Dance_Fitness_2.webp';
import quoteImg from '../../static/img/class_types_page/FreeDance_Low_Impact_Dance_Fitness_3.webp';

const Class = {
  code: 'freedance',
  name: 'The FreeDance Class',
  sentence1: 'Nia FreeDance provides a barefoot conscious dance experience designed to awaken the dancer within and stimulate creativity and expression. Participants are guided to explore their own movement and dance, in their own way and time own time to soul-stirring music, eclectic sonic landscapes that provide cellular resonance and evoke self-expression.',
  sentence2: '',
  quoteSentence1: 'Hands down best movement life therapy I’ve experienced. The music will call you, the rhythms will send you tapping, twirling, stretching, flowing to heal this one of a kind body we’ve been gifted with.',
  quoteAttr: 'Ellen P., Nia Student',
  img1,
  img2,
  quoteImg,
  img1Alt: 'A person jumping up with their arms outstretched outdoors, illustrating how fun and playful Nia\'s low impact dance fitness classes are.',
  img2Alt: 'A group of people dancing while participating in one of Nia\'s low impact dance fitness classes',
  quoteAlt: 'A quote that says "The art of creative movement" in purple script writing, illustrating how meaningful and fun Nia\'s low impact dance fitness classes are',
};

export default Class;
